'use strict'

import Vue, { PluginObject, VueConstructor } from 'vue'
import axios, { AxiosInstance } from 'axios'
import store from '@/store'
import { Actions } from '@/store/actions'
import router from '@/router'
import qs from 'qs'
import { RouteNames } from '@/router/routes'
import { ResponseStatusCodes } from '@/data/services/ApiService'
import i18n from '@/plugins/i18n'

const config = {
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 0, // Timeout
  withCredentials: true, // Check cross-site Access-Control,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  paramsSerializer: function (params: any) {
    return qs.stringify(params, { arrayFormat: 'brackets' })
  }
}

const _axios: AxiosInstance = axios.create(config)

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response
  },
  async function(error) {
    if (error.response && (error.response.status === ResponseStatusCodes.UNAUTHORIZED_ERROR || error.response.status === ResponseStatusCodes.SESSION_EXPIRED_ERROR) && !error.response.request.responseURL.includes('auth/me')) {
      store.dispatch(Actions.AUTH_LOGOUT)
      store.dispatch(Actions.APP_DESTROY)

      store.dispatch(Actions.ALERT, {
        text: i18n.t('alert.authentication_expired.error'),
        color: 'error'
      })

      return await router.push({ name: RouteNames.LOGIN })
    }

    return Promise.reject(error)
  }
)

const axiosPlugin: PluginObject<{}> = {
  install: function(_Vue: VueConstructor) {
    Object.assign(_Vue.prototype, {
      get $axios() {
        return _axios
      },
      get $http() {
        return _axios
      }
    })
  }
}

Vue.use(axiosPlugin)

export default _axios
